import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Modal, ModalProps, ModalWrapper } from '@shared/ui/organisms';
import { withTheme } from '@shared/lib/theme';
import ModalContent from './ModalContent';
type NewAccountsIntructionModalDesktopProps = ModalProps;
const NewAccountsIntructionModalDesktop: FC<NewAccountsIntructionModalDesktopProps> = ({
  open,
  onClose
}) => <Modal mobile open={open} onClose={onClose}>
    <ModalWrapper>
      <ContentWrapper>
        <ModalContent onClose={onClose} />
      </ContentWrapper>
    </ModalWrapper>
  </Modal>;
export default NewAccountsIntructionModalDesktop;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "co8bd5a",
  propsAsIs: false,
  vars: {
    "co8bd5a-0": [_exp()]
  }
}));

require("./NewAccountsIntructionModalDesktop.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NewAccountsIntructionModalDesktop.tsx");